import axios from '@/plugins/http'

export const getTicketList = storeId => {
  return axios.get(`/api/v1/stores/${storeId}/tickets-list`)
}
